/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Hmotnost obuvi (g)`
};

const da_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe weight (g)`
};

const de_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Gewicht des Schuhs (g)`
};

const en_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe weight (g)`
};

const es_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Peso del zapato (g)`
};

const fr_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Poids de la chaussure (g)`
};

const hu_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Cipő Súlya (g)`
};

const it_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Peso della scarpa (g)`
};

const nl_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Schoengewicht (g)`
};

const pl_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Waga buta (g)`
};

const pt_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Peso do sapato (g)`
};

const sv_attributes_shoe_weight = /** @type {(inputs: {}) => string} */ () => {
	return `Skons vikt (g)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_shoe_weight = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_shoe_weight(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_shoe_weight", locale)
	if (locale === "cs") return cs_attributes_shoe_weight(inputs)
	if (locale === "da") return da_attributes_shoe_weight(inputs)
	if (locale === "de") return de_attributes_shoe_weight(inputs)
	if (locale === "en") return en_attributes_shoe_weight(inputs)
	if (locale === "es") return es_attributes_shoe_weight(inputs)
	if (locale === "fr") return fr_attributes_shoe_weight(inputs)
	if (locale === "hu") return hu_attributes_shoe_weight(inputs)
	if (locale === "it") return it_attributes_shoe_weight(inputs)
	if (locale === "nl") return nl_attributes_shoe_weight(inputs)
	if (locale === "pl") return pl_attributes_shoe_weight(inputs)
	if (locale === "pt") return pt_attributes_shoe_weight(inputs)
	return sv_attributes_shoe_weight(inputs)
};
export { attributes_shoe_weight as "attributes.shoe_weight" }